/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeActions from "../../models/store/storeActions";
import * as storeEffects from "../../models/store/storeEffects";
import { Base } from "ui/Scripts/source/framework/base";
import { IInstantMessageChannelListStateProps, IInstantMessageChannelListDispatchProps, IInstantMessageChannelListOwnProps, InstantMessageChannelList } from "../../components/instantMessage/instantMessageChannelList";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IInstantMessageChannelListOwnProps): IInstantMessageChannelListStateProps {
    if (Base.isNullOrUndefined(applicationState) || Base.isNullOrUndefined(applicationState.task) || Base.isNullOrUndefined(applicationState.task.taskList)) {
        return {
            user: null,
            isLoading: false,
            items: [],
            lastOpenedInstantMessageChannelId: "",
        };
    }
    const instantMessageChannelList = applicationState.instantMessage.instantMessageChannelList;
    return {
        user: applicationState.user,
        isLoading: instantMessageChannelList.isLoading,
        items: instantMessageChannelList.items,
        lastOpenedInstantMessageChannelId: instantMessageChannelList.lastOpenedInstantMessageChannelId,
    };
}

export function mapDispatchToProps(dispatch: storeEffects.InstantMessageThunkDispatch): IInstantMessageChannelListDispatchProps {
    return {
        loadInstantMessageChannels: () => dispatch(storeEffects.getInstantMessageChannelList()),
        resetInstantMessageChannels: () => dispatch(storeActions.instantMessageChannelListReset()),
        setLastOpenedInstantMessageChannelId: (id: string) => dispatch(storeActions.instantMessageChannelListSetLastOpened(id)),
        setReturnUrl: (url: string) => dispatch(storeActions.instantMessageChannelOpenSetReturnUrl(url)),
        onLogout: () => dispatch(storeEffects.logout())
    };
}

export default connect<IInstantMessageChannelListStateProps, IInstantMessageChannelListDispatchProps, IInstantMessageChannelListOwnProps>(mapStateToProps, mapDispatchToProps)(InstantMessageChannelList);